/*
* Thème: PERFORMANCE
*/

/*
* Side Arrows
*/

function updateSwiperHeight(swiper) {
  let swiperHeight = swiper.el.querySelector('.grid').clientHeight;
  let wrapper = swiper.$el[0].closest('.carousel__container')
  if (wrapper) {
    wrapper.style.setProperty('--swiper-height', `${swiperHeight}px`);
  }
}

window.Carousel_SideArrows = function() {
  return {
    on: {
      init: function (swiper) {
        if (swiper.$el.closest('.carousel__container').find('button.swiper-button-prev').length == 0) {
          swiper.$el.closest('.carousel__container').append('<button class="swiper-button-prev"></button>')
          swiper.$el.closest('.carousel__container').append('<button class="swiper-button-next"></button>')
          $('.carousel__container button.swiper-button-next').click(function() {
            $(this).closest('.carousel__container').find('div.swiper-button-next').click()
          })
          $('.carousel__container button.swiper-button-prev').click(function() {
            $(this).closest('.carousel__container').find('div.swiper-button-prev').click()
          })
        }
        updateSwiperHeight(swiper);
      },
      slideChangeTransitionEnd: updateSwiperHeight,
    },
  }
}

/* End: PERFORMANCE */
